
import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';

import ToggleButton from './ToggleButton';
import CardChat from './CardChat';
export default function ChatContainer() {
  const [isChatOpen, setChatOpen] = useState(false);
  const [showNotificationBadge, setNotificationBadge] = useState(false);


  const handleToggleChat = () => {
    
    setChatOpen((prev) => {
      console.log('Setting chat to:', !prev); 
      return !prev;
    });

    if (!isChatOpen) {
      setNotificationBadge(false);
    }
  };

  const handleCloseChat = () => {

    setChatOpen(false);
  };



  return (
    <div style={{ position: 'relative', zIndex: 9999 }}>
      <ToggleButton onClick={handleToggleChat} showBadge={showNotificationBadge} />
        {isChatOpen && <CardChat key="chat-card" onClose={handleCloseChat} />}
    </div>
  );
}